<div class="pic-modal">
  <div class="pic-head">
    <h2 class="pic-title">Change picture</h2>
    <button type="button" class="pic-close" (click)="closemodel()" aria-label="Close" [disabled]="uploading">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
    </button>
  </div>

  <div class="pic-body" [formGroup]="playerdetailform">
    <div class="pic-cropper" [class.is-empty]="!hasPicture">
      <div #croppieElement></div>
      @if (!hasPicture) {
        <label for="picFileInput" class="pic-empty">
          <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" /><circle cx="9" cy="11" r="2" /><path d="m21 17-5-5-8 7" /></svg>
          <span>Choose a picture</span>
        </label>
      }
    </div>

    <div class="pic-hint">
      @if (hasPicture) {
        Drag to move it, use the slider to zoom.
      } @else {
        JPG or PNG. You can move and zoom it next.
      }
    </div>

    <label for="picFileInput" class="btn btn-dark btn-sm pic-choose">
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 16V4M7 9l5-5 5 5" /><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3" /></svg>
      {{ hasPicture ? 'Choose another' : 'Choose a picture' }}
    </label>
    <input type="file" (change)="handleFileInput($event)" accept="image/*" id="picFileInput" hidden />

    @if (errorMessage) {
      <div class="pic-error" role="alert">{{ errorMessage }}</div>
    }
  </div>

  <div class="pic-actions">
    <button type="button" class="btn btn-dark" (click)="closemodel()" [disabled]="uploading">Cancel</button>
    <button type="button" class="btn btn-theme" (click)="uploadImage()" [disabled]="!picked || uploading">
      {{ uploading ? 'Saving…' : 'Save picture' }}
    </button>
  </div>
</div>
